import { RichTextFooterItem } from '@framework/form';
import * as React from 'react';
import { useWatch } from 'react-hook-form';
import { InfoIconInputPreview } from '../InfoIconInputPreview';

export interface IRichTextItemFooterDisplayProps {
  name: string;
}

export function RichTextItemFooterDisplay(
  props: IRichTextItemFooterDisplayProps,
) {
  const [rule, type] = useWatch({
    name: [`${props.name}.rule`, `${props.name}.type`],
  });

  if (type !== 'info' && rule == null) return null;

  return (
    <div>
      {type === 'info' && <InfoIconInputPreview name={`${props.name}.text`} />}
      {rule && (
        <RichTextFooterItem>
          {/* //TODO integrare componente visualizzazione regole */}
          {/* <FixturesRulesFakeExemple /> */}
        </RichTextFooterItem>
      )}
    </div>
  );
}
